import { User } from '@models';
import justClone from 'just-clone';

export abstract class SuperModel {
  id?: string;
  created?: string | Date;
  modified?: string | Date;
  createdBy: string | User;
  modifiedBy: string | User;

  constructor(data: any = {}) {
    Object.assign(this, data);
    if (!data) {
      return;
    }

    if (data.created) {
      this.created = new Date(data.created);
    }
    if (data.modified) {
      this.modified = new Date(data.modified);
    }
    // if (data.createdBy) {
    //   this.createdBy = new User(object.createdBy);
    // }
    // if (data.modifiedBy) {
    //   this.modifiedBy = new User(object.modifiedBy);
    // }
  }

  abstract readonly serialised;

  get clone() {
    return justClone(this.serialised);
  }
}
